import { useEffect, useState } from 'react'
import { apiConstants, getGeneric } from '../common/constants'

// Fetches the couriers this merchant holds rate cards (active SLAs) for, via
// GET courierPartner/merchant/{merchantOid}/allocated — the same endpoint the old
// CourierAccountFilter used, but returning the raw list so a Courier(parent) dropdown
// and a cascading Service Type dropdown can both derive their options from one fetch.
export default function useMerchantAllocatedCouriers(merchantId) {
    const [couriers, setCouriers] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (!merchantId) { setCouriers([]); return }
        let active = true
        setIsLoading(true)
        getGeneric(`${apiConstants.COURIERS}/merchant/${merchantId}/allocated`)
            .then((res) => {
                if (!active) return
                setCouriers(Array.isArray(res?.data) ? res.data : [])
            })
            .catch((err) => {
                console.error('Error fetching merchant-allocated couriers:', err)
                if (active) setCouriers([])
            })
            .finally(() => { if (active) setIsLoading(false) })
        return () => { active = false }
    }, [merchantId])

    return { couriers, isLoading }
}
